import React from "react";
import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    label: "The Debut",
    body: "FRE3BRD is the first full statement — ten tracks written, recorded and sequenced as one continuous body of work. No filler. Just the tape.",
  },
  {
    n: "02",
    label: "Free To All",
    body: "Every song streams right here, and the entire project is free to download. Drop an email once and the full tape is yours to keep.",
  },
  {
    n: "03",
    label: "Everywhere",
    body: "Prefer your own player? FRE3BRD lives on Spotify, Apple Music and YouTube. Same tape, your platform, zero cost.",
  },
];

export default function Manifesto() {
  return (
    <section
      data-testid="manifesto-section"
      className="relative w-full px-5 md:px-10 py-20 md:py-28 border-t border-zinc-900"
    >
      <div className="max-w-5xl mx-auto w-full">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="flex flex-col"
            >
              <span className="font-display font-black text-6xl md:text-7xl leading-none text-white/10 tracking-tighter mb-5">
                {c.n}
              </span>
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-white mb-3">
                {c.label}
              </span>
              <p className="font-body text-sm md:text-base text-zinc-400 leading-relaxed max-w-xs">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
